"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportedAggregatesConstants = exports.timeDimensionsConstants = exports.supportedOperatorsConstants = void 0;
exports.supportedOperatorsConstants = {
    '>': {
        publicName: 'Greater than',
        validDataTypes: ['number', 'date_time'],
    },
    '<': {
        publicName: 'Less than',
        validDataTypes: ['number', 'date_time'],
    },
    '<=': {
        publicName: 'Less than or equal to',
        validDataTypes: ['number', 'date_time'],
    },
    '>=': {
        publicName: 'Greater than or equal to',
        validDataTypes: ['number', 'date_time'],
    },
    '!=': {
        publicName: 'Not equal to',
        validDataTypes: ['number', 'date_time', 'boolean', 'string'],
    },
    is_one_of: {
        publicName: 'Is one of',
        validDataTypes: ['number', 'date_time', 'boolean', 'string'],
    },
    '=': {
        publicName: 'Equal to',
        validDataTypes: ['number', 'date_time', 'boolean', 'string'],
    },
    is_not_one_of: {
        publicName: 'Is not one of',
        validDataTypes: ['number', 'date_time', 'boolean', 'string'],
    },
    starts_with: {
        publicName: 'Starts with',
        validDataTypes: ['string'],
    },
    ends_with: {
        publicName: 'Ends with',
        validDataTypes: ['string'],
    },
    contains_substring: {
        publicName: 'Contains text',
        validDataTypes: ['string'],
    },
    does_not_contain_substring: {
        publicName: 'Does not contain text',
        validDataTypes: ['string'],
    },
    array_contains: {
        publicName: 'Contains',
        validDataTypes: ['string[]'],
    },
    array_does_not_contain: {
        publicName: 'Does not contain',
        validDataTypes: ['string[]'],
    },
    array_contains_any_of: {
        publicName: 'Contains any of',
        validDataTypes: ['string[]'],
    },
    array_contains_all_of: {
        publicName: 'Contains all of',
        validDataTypes: ['string[]'],
    },
};
exports.timeDimensionsConstants = {
    month: {
        publicName: 'Monthly',
        dateFormat: 'MMMM YYYY',
    },
    year: {
        publicName: 'Yearly',
        dateFormat: 'YYYY',
    },
    quarter: {
        publicName: 'Per quarter',
        dateFormat: 'quarter',
    },
    week: {
        publicName: 'Weekly',
        dateFormat: 'week',
    },
    day: {
        publicName: 'Daily',
        dateFormat: 'DD-MM-YYYY',
    },
    hourOfDayOnly: {
        publicName: 'Hour of day',
        dateFormat: 'hour_of_day',
    },
    weekOfYearOnly: {
        publicName: 'Week of year',
        dateFormat: 'week_of_year',
    },
    dayOfWeekOnly: {
        publicName: 'Day of week',
        dateFormat: 'day_of_week_iso',
    },
    dayOfMonthOnly: {
        publicName: 'Day of month',
        dateFormat: 'day_of_month',
    },
    second: {
        publicName: 'Per second',
        dateFormat: 'hh:mm:ss',
    },
    hour: {
        publicName: 'Hourly',
        dateFormat: 'hh:mm',
    },
    minute: {
        publicName: 'Per minute',
        dateFormat: 'hh:mm',
    },
};
exports.supportedAggregatesConstants = {
    mean: {
        publicName: 'Mean',
        validDataTypes: ['number'],
    },
    sum: {
        publicName: 'Sum',
        validDataTypes: ['number'],
    },
    min: {
        publicName: 'Min',
        validDataTypes: ['number'],
    },
    max: {
        publicName: 'Max',
        validDataTypes: ['number'],
    },
    count: {
        publicName: 'Count',
        validDataTypes: ['string', 'number', 'boolean', 'date_time', 'string[]'],
    },
    countDistinct: {
        publicName: 'Unique',
        validDataTypes: ['string', 'number', 'boolean', 'date_time'],
    },
    median: {
        publicName: 'Median',
        validDataTypes: ['number'],
    },
    percentile25: {
        publicName: '25th percentile',
        validDataTypes: ['number'],
    },
    percentile75: {
        publicName: '75th percentile',
        validDataTypes: ['number'],
    },
    percentile90: {
        publicName: '90th percentile',
        validDataTypes: ['number'],
    },
    percentile95: {
        publicName: '95th percentile',
        validDataTypes: ['number'],
    },
    percentile99: {
        publicName: '99th percentile',
        validDataTypes: ['number'],
    },
};
